module.exports = __webpack_public_path__ + "img/TRT_Default_Image.1d2f2bb6.png";